import {
  Button,
  Checkbox,
  FormHelperText,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Tooltip from "@mui/material/Tooltip";
import { ProgressBar } from "react-bootstrap";
import Cross from "../../../Assets/Svgs/Cross";
import FIlesvg from "../../../Assets/Svgs/FIlesvg";
const Graduationfields = [
  { id: "one", name: "grad_semone", label: "one" },
  { id: "sem-two", name: "grad_semtwo", label: "two" },
  { id: "sem-three", name: "grad_semthree", label: "three" },
  { id: "sem-four", name: "grad_semfour", label: "four" },
  { id: "sem-five", name: "grad_semfive", label: "five" },
  { id: "sem-six", name: "grad_semsix", label: "six" },
  { id: "sem-seven", name: "grad_semseven", label: "seven" },
  { id: "sem-eight", name: "grad_semeight", label: "eight" },
];
const postgraduatefields = [
  { id: "post_sem_one", name: "postgrad_semone", label: "one" },
  { id: "post_sem_two", name: "postgrad_semtwo", label: "two" },
  { id: "post_sem_three", name: "postgrad_semthree", label: "three" },
  { id: "post_sem_four", name: "postgrad_semfour", label: "four" },
];

const EducationalDetail = ({
  handleChange,
  userportaldata,
  errors,
  graduationchecked,
  setgraduationchecked,
  postgraduate,
  setPostgraduate,
  Percente,
  handleRemovefile,
  removeButton,
}) => {
  return (
    <Stack
      direction={"column"}
      sx={{
        display: "flex",
        gap: "20px",
        width: "100%",
      }}
    >
      <Stack direction={"row"} gap={"30px"} alignItems={"center"}>
        <Typography
          component={"span"}
          variant="caption"
          sx={{
            fontSize: "15px",
            fontWeight: "500",
            color: "black",
            textAlign: "center",
          }}
        >
          10<sup>th</sup>:
        </Typography>
        {(Array.isArray(userportaldata?.Educational["10th"]) &&
          userportaldata?.Educational["10th"][0] === false) ||
        !userportaldata?.Educational["10th"] ? (
          <>
            {Percente[`10th_progress`] > 0 ? (
              <></>
            ) : (
              <>
                <input
                  type="file"
                  name="10th"
                  id="file-input-10th"
                  style={{ display: "none" }}
                  onChange={handleChange}
                  multiple
                />
                <label htmlFor="file-input-10th">
                  <Button
                    variant="contained"
                    component="span"
                    className="btn-light"
                    sx={{
                      padding: "3px 16px !important",
                      height: "40px",
                      fontSize: "13px !important",
                      ":hover": {
                        padding: "3px 16px !important",
                        fontSize: "13px !important",
                        height: "40px",
                      },
                    }}
                  >
                    Upload File
                  </Button>
                </label>
              </>
            )}
          </>
        ) : (
          <Stack>
            <Tooltip
              sx={{
                height: "0px",
                width: "0px",
                margin: "0px 0px -5px 27px",
              }}
            >
              <IconButton onClick={() => handleRemovefile("10th")}>
                <Cross />
              </IconButton>
            </Tooltip>
            <FIlesvg />
          </Stack>
        )}
        {Percente[`10th_progress`] > 0 && (
          <ProgressBar
            animated
            now={Percente[`10th_progress`]}
            label={`${Percente[`10th_progress`]}%`}
            style={{ width: window.innerWidth < 600 ? "60%" : "30%" }}
          />
        )}
        {errors["10th"] && (
          <FormHelperText error>{errors["10th"]}</FormHelperText>
        )}
      </Stack>
      <Stack direction={"row"} gap={"30px"} alignItems={"center"}>
        <Typography
          component={"span"}
          variant="caption"
          sx={{
            fontSize: "15px",
            fontWeight: "500",
            color: "black",
            textAlign: "center",
          }}
        >
          12<sup>th</sup>:
        </Typography>
        {(Array.isArray(userportaldata?.Educational["12th"]) &&
          userportaldata?.Educational["12th"][0] === false) ||
        !userportaldata?.Educational["12th"] ? (
          <>
            {Percente[`12th_progress`] > 0 ? (
              <></>
            ) : (
              <>
                <input
                  type="file"
                  name="12th"
                  id="file-input-12th"
                  style={{ display: "none" }}
                  onChange={handleChange}
                />
                <label htmlFor="file-input-12th">
                  <Button
                    variant="contained"
                    component="span"
                    className="btn-light"
                    sx={{
                      padding: "3px 16px !important",
                      height: "40px",
                      fontSize: "13px !important",
                      ":hover": {
                        padding: "3px 16px !important",
                        fontSize: "13px !important",
                        height: "40px",
                      },
                    }}
                  >
                    Upload File
                  </Button>
                </label>
              </>
            )}
          </>
        ) : (
          <Stack>
            <Tooltip
              sx={{
                height: "0px",
                width: "0px",
                margin: "0px 0px -5px 27px",
              }}
            >
              <IconButton onClick={() => handleRemovefile("12th")}>
                <Cross />
              </IconButton>
            </Tooltip>
            <FIlesvg />
          </Stack>
        )}
        {Percente[`12th_progress`] > 0 && (
          <ProgressBar
            animated
            now={Percente[`12th_progress`]}
            label={`${Percente[`12th_progress`]}%`}
            style={{ width: window.innerWidth < 600 ? "60%" : "30%" }}
          />
        )}

        {errors["12th"] && (
          <FormHelperText error>{errors["12th"]}</FormHelperText>
        )}
      </Stack>
      <Stack
        direction={"column"}
        sx={{
          width: "100%",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={graduationchecked}
              onChange={(e) =>
                setgraduationchecked(
                  e.target.checked,
                  e.target.checked === false &&
                    setPostgraduate(e.target.checked)
                )
              }
            />
          }
          label="do you have a graduate degree"
        />
        {graduationchecked && (
          <Stack
            direction={"column"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: "25px",
              justifyContent: "flex-start",
            }}
          >
            <Stack
              direction={"row"}
              gap={"10px"}
              sx={{
                width: "100%",
              }}
            >
              <Typography
                component={"span"}
                variant="caption"
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "black",
                  textAlign: "center",
                }}
              >
                Graduation Degree:
              </Typography>
              {(Array.isArray(userportaldata?.Educational.grad_degree) &&
                userportaldata?.Educational.grad_degree[0] === false) ||
              !userportaldata?.Educational.grad_degree ? (
                <>
                  {Percente[`grad_degree_progress`] > 1 ? (
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      className="progressBar_Verificationportal"
                    >
                      {Percente[`grad_degree_progress`] > 1 && (
                        <ProgressBar
                          animated
                          now={Percente[`grad_degree_progress`]}
                          label={`${Percente[`grad_degree_progress`]}%`}
                          style={{ width: "100%" }}
                        />
                      )}
                      {errors["grad_degree"] && (
                        <FormHelperText error>
                          {errors["grad_degree"]}
                        </FormHelperText>
                      )}
                    </Stack>
                  ) : (
                    <>
                      <input
                        type="file"
                        id="file-input-grad"
                        style={{ display: "none" }}
                        onChange={handleChange}
                        name="grad_degree"
                      />
                      <label htmlFor="file-input-grad">
                        <Button
                          variant="contained"
                          component="span"
                          className="btn-light"
                          sx={{
                            padding: "3px 16px !important",
                            height: "40px",
                            fontSize: {
                              xs: "10px !important",
                              sm: "10px !important",
                              md: "13px !important",
                              lg: "13px !important",
                            },
                            minWidth: "120px",
                            ":hover": {
                              padding: "3px 16px !important",
                              fontSize: "13px !important",
                              height: "40px",
                            },
                          }}
                        >
                          Upload File
                        </Button>
                      </label>
                    </>
                  )}
                </>
              ) : (
                <Stack>
                  <Tooltip
                    sx={{
                      height: "0px",
                      width: "0px",
                      margin: "0px 0px -5px 27px",
                    }}
                  >
                    <IconButton onClick={() => handleRemovefile("grad_degree")}>
                      <Cross />
                    </IconButton>
                  </Tooltip>
                  <FIlesvg />
                </Stack>
              )}
            </Stack>
            <Typography
              component={"span"}
              variant="caption"
              sx={{
                fontSize: "15px",
                fontWeight: "500",
                color: "black",
              }}
            >
              Graduation Sam:
            </Typography>
            <Stack
              direction={"column"}
              gap={"15px"}
              sx={{
                display: "flex",
                flexWrap: "wrap",
                width: "100%",
                height: window.innerWidth < 600 ? "" : "",
              }}
            >
              {Graduationfields.map((item, i) => (
                <Stack
                  key={item.id || i}
                  direction={"row"}
                  alignItems={"center"}
                  sx={{
                    gap: "30px",
                  }}
                >
                  {(Array.isArray(userportaldata?.Educational[item.name]) &&
                    userportaldata?.Educational[item.name][0] === false) ||
                  !userportaldata?.Educational[item.name] ? (
                    <>
                      {Percente[`${item.name}_progress`] > 1 ? (
                        <Stack
                          key={item.id || item.label}
                          direction={"row"}
                          gap={2}
                          sx={{ width: "100%" }}
                        >
                          <Typography
                            component="span"
                            variant="subtitle2"
                            sx={{
                              fontSize: { xs: "14px", sm: "15px" },
                              fontWeight: 500,
                              color: "text.primary",
                              minWidth: { xs: "auto", sm: "30px" },
                            }}
                          >
                            {item.label}:
                          </Typography>
                          <Stack
                            direction="row"
                            alignItems="center"
                            sx={{
                              width: {
                                xs: "100%",
                                sm: "50%",
                                md: "40%",
                                lg: "30%",
                              },
                              maxWidth: "400px",
                            }}
                          >
                            <ProgressBar
                              animated
                              now={Percente[`${item.name}_progress`]}
                              label={`${Percente[`${item.name}_progress`]}%`}
                              style={{ width: "100%" }}
                            />
                            {errors[item.name] && (
                              <FormHelperText error sx={{ mt: 1 }}>
                                {errors[item.name]}
                              </FormHelperText>
                            )}
                          </Stack>
                        </Stack>
                      ) : (
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          sx={{
                            gap: "30px",
                          }}
                        >
                          <Stack
                            key={item.label || i}
                            direction={"row"}
                            gap={"20px"}
                            alignItems={"center"}
                          >
                            <>
                              <Typography
                                component={"span"}
                                variant="caption"
                                sx={{
                                  fontSize: "15px",
                                  fontWeight: "500",
                                  color: "black",
                                  width: "50px",
                                }}
                              >
                                {item.label}:
                              </Typography>
                              <input
                                type="file"
                                id={item.id}
                                name={item.name}
                                style={{ display: "none" }}
                                onChange={handleChange}
                              />
                              <label htmlFor={item.id}>
                                <Button
                                  variant="contained"
                                  component="span"
                                  className="btn-light"
                                  sx={{
                                    padding: "3px 16px !important",
                                    height: "40px",
                                    fontSize: {
                                      xs: "10px !important",
                                      sm: "10px !important",
                                      md: "13px !important",
                                      lg: "13px !important",
                                    },
                                    minWidth: "120px",
                                    ":hover": {
                                      padding: "3px 16px !important",
                                      height: "40px",
                                      fontSize: {
                                        xs: "10px !important",
                                        sm: "10px !important",
                                        md: "13px !important",
                                        lg: "13px !important",
                                      },
                                    },
                                  }}
                                >
                                  Upload File
                                </Button>
                              </label>
                            </>
                          </Stack>
                        </Stack>
                      )}
                    </>
                  ) : (
                    <Stack
                      key={item.label || i}
                      direction={"row"}
                      gap={"20px"}
                      alignItems={"center"}
                    >
                      <Typography
                        component={"span"}
                        variant="caption"
                        sx={{
                          fontSize: "15px",
                          fontWeight: "00",
                          color: "black",
                          width: "50px",
                        }}
                      >
                        {item.label}:
                      </Typography>
                      <Stack>
                        <Tooltip
                          sx={{
                            height: "0px",
                            width: "0px",
                            margin: "0px 0px -5px 27px",
                          }}
                        >
                          <IconButton
                            onClick={() => handleRemovefile(item.name)}
                          >
                            <Cross />
                          </IconButton>
                        </Tooltip>
                        <FIlesvg />
                      </Stack>
                    </Stack>
                  )}
                </Stack>
              ))}
            </Stack>
          </Stack>
        )}
      </Stack>
      <Stack
        direction={"column"}
        sx={{
          width: "100%",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={postgraduate}
              onChange={(e) => {
                setPostgraduate(
                  e.target.checked,
                  e.target.checked === true &&
                    setgraduationchecked(e.target.checked)
                );
              }}
            />
          }
          label="do you have a post graduate degree"
        />
        {postgraduate && (
          <Stack
            direction={"column"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: "30px",
              justifyContent: "flex-start",
              "@media(max-width:900px)": {
                // flexDirection: "column",
                alignItems: "normal",
                gap: "10px",
              },
            }}
          >
            <Stack
              direction={"row"}
              gap={"10px"}
              sx={{
                width: "100%",
              }}
            >
              <Typography
                component={"span"}
                variant="caption"
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "black",
                  width: "150px",
                }}
              >
                Graduation Degree:
              </Typography>
              {(Array.isArray(userportaldata?.Educational.postgrad_degree) &&
                userportaldata?.Educational.postgrad_degree[0] === false) ||
              !userportaldata?.Educational.postgrad_degree ? (
                <>
                  {Percente[`postgrad_degree_progress`] > 1 ? (
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      className="progressBar_Verificationportal"
                    >
                      {Percente[`postgrad_degree_progress`] > 1 && (
                        <ProgressBar
                          animated
                          now={Percente[`postgrad_degree_progress`]}
                          label={`${Percente[`postgrad_degree_progress`]}%`}
                          style={{ width: "100%" }}
                        />
                      )}
                      {errors["postgrad_degree"] && (
                        <FormHelperText error>
                          {errors["postgrad_degree"]}
                        </FormHelperText>
                      )}
                    </Stack>
                  ) : (
                    <>
                      <input
                        type="file"
                        id="file-input-postgrad"
                        style={{ display: "none" }}
                        onChange={handleChange}
                        name="postgrad_degree"
                      />
                      <label htmlFor="file-input-postgrad">
                        <Button
                          variant="contained"
                          component="span"
                          className="btn-light"
                          sx={{
                            padding: "3px 16px !important",
                            height: "40px",
                            fontSize: {
                              xs: "10px !important",
                              sm: "10px !important",
                              md: "13px !important",
                              lg: "13px !important",
                            },
                            minWidth: "120px",
                            ":hover": {
                              padding: "3px 16px !important",
                              height: "40px",
                              fontSize: {
                                xs: "10px !important",
                                sm: "10px !important",
                                md: "13px !important",
                                lg: "13px !important",
                              },
                            },
                          }}
                        >
                          Upload File
                        </Button>
                      </label>
                    </>
                  )}
                </>
              ) : (
                <Stack>
                  <Tooltip
                    sx={{
                      height: "0px",
                      width: "0px",
                      margin: "0px 0px -5px 27px",
                    }}
                  >
                    <IconButton
                      onClick={() => handleRemovefile("postgrad_degree")}
                    >
                      <Cross />
                    </IconButton>
                  </Tooltip>
                  <FIlesvg />
                </Stack>
              )}
            </Stack>
            <Typography
              component={"span"}
              variant="caption"
              sx={{
                fontSize: "15px",
                fontWeight: "500",
                color: "black",
              }}
            >
              Graduation Sam:
            </Typography>
            <Stack
              direction={"column"}
              gap={"20px"}
              sx={{
                display: "flex",
                flexWrap: "wrap",
                width: "100%",
                "@media(max-width:600px)": {
                  // flexDirection: "column",
                  height: "auto",
                },
              }}
            >
              {postgraduatefields.map((item, i) => (
                <Stack
                  key={i || item.id}
                  direction={"row"}
                  gap={"30px"}
                  alignItems={"center"}
                >
                  {(Array.isArray(userportaldata?.Educational[item.name]) &&
                    userportaldata?.Educational[item.name][0] === false) ||
                  !userportaldata?.Educational[item.name] ? (
                    <>
                      {Percente[`${item.name}_progress`] > 1 ? (
                        <Stack
                          key={item.id || item.label}
                          direction={"row"}
                          gap={2}
                          sx={{
                            ".css-xfcqhw-MuiStack-root": {
                              flexDirection: "row",
                            },
                            width: "100%",
                          }}
                        >
                          <Typography
                            component="span"
                            variant="subtitle2"
                            sx={{
                              fontSize: { xs: "14px", sm: "15px" },
                              fontWeight: 500,
                              color: "text.primary",
                              minWidth: { xs: "auto", sm: "30px" },
                            }}
                          >
                            {item.label}:
                          </Typography>
                          <Stack
                            direction="row"
                            alignItems="center"
                            sx={{
                              width: {
                                xs: "100%",
                                sm: "50%",
                                md: "40%",
                                lg: "30%",
                              },
                              maxWidth: "400px",
                            }}
                          >
                            <ProgressBar
                              animated
                              now={Percente[`${item.name}_progress`]}
                              label={`${Percente[`${item.name}_progress`]}%`}
                              style={{ width: "100%" }}
                            />
                            {errors[item.name] && (
                              <FormHelperText error sx={{ mt: 1 }}>
                                {errors[item.name]}
                              </FormHelperText>
                            )}
                          </Stack>
                        </Stack>
                      ) : (
                        <>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            sx={{
                              gap: "30px",
                            }}
                          >
                            <Stack
                              key={item.label || i}
                              direction={"row"}
                              gap={"20px"}
                              alignItems={"center"}
                            >
                              <Typography
                                component={"span"}
                                variant="caption"
                                sx={{
                                  fontSize: "15px",
                                  fontWeight: "500",
                                  color: "black",
                                  width: "50px",
                                }}
                              >
                                {item.label}:
                              </Typography>
                              <>
                                <input
                                  type="file"
                                  id={item.id}
                                  name={item.name}
                                  style={{ display: "none" }}
                                  onChange={handleChange}
                                />
                                <label htmlFor={item.id}>
                                  <Button
                                    variant="contained"
                                    component="span"
                                    className="btn-light"
                                    sx={{
                                      padding: "3px 16px !important",
                                      height: "40px",
                                      fontSize: {
                                        xs: "10px !important",
                                        sm: "10px !important",
                                        md: "13px !important",
                                        lg: "13px !important",
                                      },
                                      minWidth: "120px",
                                      ":hover": {
                                        padding: "3px 16px !important",
                                        height: "40px",
                                        fontSize: {
                                          xs: "10px !important",
                                          sm: "10px !important",
                                          md: "13px !important",
                                          lg: "13px !important",
                                        },
                                      },
                                    }}
                                  >
                                    Upload File
                                  </Button>
                                </label>
                              </>
                            </Stack>
                          </Stack>
                        </>
                      )}
                    </>
                  ) : (
                    <Stack
                      key={item.label || i}
                      direction={"row"}
                      gap={"20px"}
                      alignItems={"center"}
                    >
                      <Typography
                        component={"span"}
                        variant="caption"
                        sx={{
                          fontSize: "15px",
                          fontWeight: "00",
                          color: "black",
                          width: "50px",
                        }}
                      >
                        {item.label}:
                      </Typography>
                      <Stack>
                        <Tooltip
                          sx={{
                            height: "0px",
                            width: "0px",
                            margin: "0px 0px -5px 27px",
                          }}
                        >
                          <IconButton
                            onClick={() => handleRemovefile(item.name)}
                          >
                            <Cross />
                          </IconButton>
                        </Tooltip>
                        <FIlesvg />
                      </Stack>
                    </Stack>
                  )}
                </Stack>
              ))}
            </Stack>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default EducationalDetail;
